import { AddCircle, Delete, Edit, Save } from "@material-ui/icons";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { Button, Col, FloatingLabel, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import { useAddFuelCostMutation, useDeleteFuelCostMutation, useGetAllFuelListQuery, useUpdateFuelCostMutation } from "../../../../../features/FuelCost/FuelCostSlice";
import errorHandler from "../../../../hooks/ErrorHanlder";

const FuelCostTable = () => {
  const { register, handleSubmit, reset } = useForm();
  const [addFuel] = useAddFuelCostMutation()
  const [editFuel] = useUpdateFuelCostMutation()
  const [deleteFuel] = useDeleteFuelCostMutation()
  const { data: tableListData, refetch } = useGetAllFuelListQuery()
  const [isUpdate, setIsUpdate] = useState(false);
  const [open, setOpen] = useState(false);
  const handleClose = () => { setOpen(false); };
  const [fuelData, setFuelData] = useState([])
  const [deleteID, setDeleteID] = useState(null)

  useEffect(() => {
    setFuelData(fuelData)
    reset(fuelData)
  }, [fuelData])

  const onSubmit = async (data) => {
    try {
      await addFuel({ ...data }).unwrap()
      toast.success("Data added successfully", {
        position: "top-center",
      })
    } catch (error) {
      errorHandler(error)
    }
    reset({ effectiveDate: '', costPerGallon: '' })
    refetch()
  };

  const onEdit = async (data) => {
    try {
      await editFuel({ ...data }).unwrap()
      toast.success("Data updated successfully", {
        position: "top-center",
      })
      reset({ effectiveDate: '', costPerGallon: '' })
      refetch()
      setIsUpdate(false)
    } catch (error) {
      errorHandler(error)
    }
  }

  const deleteHandler = async () => {
    try {
      await deleteFuel(deleteID).unwrap()
      toast.success("Data deleted successfully", {
        position: "top-center",
      })
      refetch()
      setOpen(false);
    } catch (error) {
      errorHandler(error)
    }
  }

  const columns = [
    {
      field: "actions",
      headerName: "Actions",
      sortable: false,
      width: 100,
      disableClickEventBubbling: true,
      renderCell: (data) => {
        const onClick = (e) => {
          e.stopPropagation();
          setIsUpdate(true)
          let newEditItem = tableListData.data.find((row) => {
            return row.fuelCostId === data.row.id;
          });
          setFuelData(newEditItem);
          reset(fuelData)
        };
        const onRemove = (e) => {
          e.stopPropagation();
          setOpen(true);
          setDeleteID(data.row.id)
        };
        return (
          <>
            <div>
              <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" >
                <DialogTitle id="alert-dialog-title">
                  Delete Confirmation
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    Are you sure you want to delete this row?
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button className="btn-secondary" onClick={handleClose}>Cancel</Button>
                  <Button className="btn-primary" onClick={() => deleteHandler()} autoFocus> Confirm</Button>
                </DialogActions>
              </Dialog>
            </div>
            <div className="action_btn">
              <span className="edit_btn" onClick={onClick}><Edit /></span>
              <span className="del_btn" onClick={onRemove}><Delete /></span>
            </div>
          </>
        )
      },
    },
    { field: "effectiveDate", headerName: "Effective Date", width: 200 },
    { field: "costPerGallon", headerName: "Cost Per Gallon", width: 200 },
  ];

  const rows = tableListData?.data.length >= 0 && tableListData?.data.map((data) => {
    return {
      id: data?.fuelCostId,
      effectiveDate: data?.effectiveDate,
      costPerGallon: data?.costPerGallon
    }
  })




  return (
    <Row className="mb-4 mt-4">
      <Col sm={4}>
        <fieldset className="less_load_table">
          <label className="label-heading">Fuel Cost Table</label>
          <Row>
            <Col sm={12} className="justify-content-between">
              <div className="section_action_btn">
                {!isUpdate ?
                  <div className="add_btn"><button type="button" className="btn" onClick={handleSubmit(onSubmit)}><AddCircle /></button></div>
                  :
                  <div className="save_btn"><button type="button" className="btn" onClick={handleSubmit(onEdit)}><Save /></button></div>
                }
              </div>
            </Col>

            <Row className="mt-2 mb-3">
              <Col sm={12} className="mb-2">
                <Form.Group controlId="Date">
                  <FloatingLabel controlId="floatingInput" label="Date" >
                    <Form.Control type="date" placeholder="Date" name="effectiveDate" {...register("effectiveDate")} />
                  </FloatingLabel>
                </Form.Group>
              </Col>
              <Col sm={12}>
                <Form.Group controlId="ToCost">
                  <FloatingLabel controlId="floatingInput" label="Fuel Charge" >
                    <Form.Control type="number" placeholder="Fuel Charge" name="costPerGallon" {...register("costPerGallon")} />
                  </FloatingLabel>
                </Form.Group>
              </Col>
            </Row>
            <div className="user-role-table" style={{ height: "500px", background: "white" }}>
              <DataGrid rows={rows} columns={columns} pageSize={15} rowsPerPageOptions={[1]} components={{ Toolbar: GridToolbar }} />
            </div>
          </Row>
        </fieldset>
      </Col>
    </Row>
  );
}
export default FuelCostTable;